// extracted by mini-css-extract-plugin
module.exports = {"moreInfo":"th","link":"ti","linkText":"tj","linkIcon":"tk","isRental":"tl","active":"tm","synopsisAndButton":"tn","linkWrapper":"to"};